import { StoreDashboardState } from '@dashboard/dashboard-store/dashboard.state';
import {
  createFeatureSelector,
  createSelector,
  createSelectorFactory,
  defaultMemoize,
  MemoizedSelector,
} from '@ngrx/store';
import { isEqual } from 'lodash';

const dataState = createFeatureSelector<StoreDashboardState>('dashboard');
export const DeepSelector = createSelectorFactory((projectionFn) =>
  defaultMemoize(
    projectionFn,
    arraysAndObjectsComparison,
    arraysAndObjectsComparison
  )
) as typeof createSelector;
function arraysAndObjectsComparison(a: any, b: any): boolean {
  const res = isEqual(a, b);
  return res;
}

const VesselsHasError = DeepSelector(
  dataState,
  (dataState: StoreDashboardState) => {
    const vesselsData = Object.values(dataState.data);

    return (
      vesselsData.filter(
        (v) => Boolean(v.ingestion_error.formattedValue) === true
      ).length > 1
    );
  }
) as MemoizedSelector<StoreDashboardState, boolean>;

const IngestionErrorEvaluationData = createSelector(dataState, (dataState) => {
  const temp = [] as Array<{
    imo: string;
    latest_timestamp: number;
    systemHealth: string;
  }>;
  for (const [vesselImo, vesselData] of Object.entries(dataState.data)) {
    temp.push({
      imo: vesselImo,
      latest_timestamp: Number(vesselData.latest_timestamp.formattedValue),
      systemHealth: vesselData.SYSTEM_HEALTH.formattedValue,
    });
  }
  return temp;
});

export { VesselsHasError, IngestionErrorEvaluationData };
